/* eslint-disable */
import { constantRouterMap } from '@/router/index'
import Layout from '@/layout/index'

export const formatRoutes = (routers) => {
  const Router = []
  for (let i = 0; i < routers.length; i++){
    let result = []
    if (routers[i].children && routers[i].children.length) {
      result = routers[i].children.map(item => {
        return {
          component: item.criMvcUrl,
          meta: {
            icon: item.criIcon,
            title: item.criName
          },
          name: item.criName,
          path: item.criUrl || '/'
        }
      })
      Router.push({
        alwaysShow: true,
        children: result,
        component: 'Layout',
        hidden: false,
        meta: {
          icon: routers[i].criIcon,
          title: routers[i].criName,
        },
        name: routers[i].criName,
        path: routers[i].criUrl || '/',
        redirect: 'noredirect'
      })
    }
  }
  return Router
}
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    sidebarRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    SET_SIDEBAR_ROUTERS: (state, routers) => {
      state.sidebarRouters = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, menu) {
      return new Promise(resolve => {
        if (menu.length === 0) {
          return
        }
        const menus = formatRoutes(menu)
        const rdata = JSON.parse(JSON.stringify(menus))
        const rewriteRoutes = filterAsyncRouter(rdata, true)
        rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
        commit('SET_ROUTERS', rewriteRoutes)
        resolve()
      })
    },
    SetSidebarRouters({ commit }, sidebarRouter) {
      commit('SET_SIDEBAR_ROUTERS', sidebarRouter)
    }
  }
}

export const filterAsyncRouter = (routers, isRewrite = false) => { // 遍历后台传来的路由字符串，转换为组件对象
  return routers.filter(router => {
    if (isRewrite && router.children) {
      router.children = filterChildren(router.children)
    }
    if (router.component) {
      if (router.component === 'Layout') { // Layout组件特殊处理
        router.component = Layout
      } else {
        const component = router.component
        router.component = loadView(component)
      }
    }
    if (router.children && router.children.length) {
      router.children = filterAsyncRouter(router.children, router, isRewrite)
    }
    return true
  })
}

function filterChildren(childrenMap) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView') {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    children = children.concat(el)
  })
  return children
}

export const loadView = (view) => {
  return (resolve) => require([`@/views/${view}`], resolve)
}

export default permission
/* eslint-disable */